// @ts-nocheck
/* Verbatim port of v1 components/partials/dashboard/users/company.js */
import { useState } from 'react';
import React from 'react';
import { Card as ShadCard } from '@/components/ui/card';
import { Button as _ShadButton } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

const _cx = (...args: any[]) => args.filter(Boolean).join(' ');
const Container: any = ({ fluid, className, children, ...props }: any) => (
  <div className={_cx(fluid ? 'container-fluid' : 'container', className)} {...props}>
    {children}
  </div>
);
const Row: any = ({ className, children, ...props }: any) => (
  <div className={_cx('row', className)} {...props}>
    {children}
  </div>
);
const _colCls = ({ xs, sm, md, lg, xl }: any) => {
  const parts = [];
  if (md) parts.push(`col-md-${md}`);
  if (lg) parts.push(`col-lg-${lg}`);
  if (xl) parts.push(`col-xl-${xl}`);
  if (sm) parts.push(`col-sm-${sm}`);
  if (xs) parts.push(`col-${xs}`);
  if (!parts.length) parts.push('col');
  return parts.join(' ');
};
const Col: any = ({ xs, sm, md, lg, xl, className, children, ...props }: any) => (
  <div className={_cx(_colCls({ xs, sm, md, lg, xl }), className)} {...props}>
    {children}
  </div>
);
const _btnVariantMap: Record<string, any> = {
  primary: 'default',
  secondary: 'outline',
  danger: 'destructive',
  light: 'outline',
  link: 'link',
};
const _Unused_Button: any = ({ variant, size, className, children, ...props }: any) => {
  let mapped = variant;
  if (typeof variant === 'string') {
    if (variant.startsWith('outline-')) mapped = 'outline';
    else if (_btnVariantMap[variant]) mapped = _btnVariantMap[variant];
    else if (variant.startsWith('btn ')) mapped = 'default';
  }
  return (
    <_ShadButton variant={mapped} size={size} className={className} {...props}>
      {children}
    </_ShadButton>
  );
};
const _Unused_Card: any = ({ className, children, ...props }: any) => (
  <ShadCard className={className} {...props}>
    {children}
  </ShadCard>
);
_Unused_Card.Header = ({ className, children, ...props }: any) => (
  <div className={_cx('card-header', className)} {...props}>
    {children}
  </div>
);
_Unused_Card.Body = ({ className, children, ...props }: any) => (
  <div className={_cx('card-body', className)} {...props}>
    {children}
  </div>
);
_Unused_Card.Title = ({ as: As = 'h5', className, children, ...props }: any) => (
  <As className={_cx('card-title', className)} {...props}>
    {children}
  </As>
);
_Unused_Card.Text = ({ className, children, ...props }: any) => (
  <p className={_cx('card-text', className)} {...props}>
    {children}
  </p>
);
_Unused_Card.Footer = ({ className, children, ...props }: any) => (
  <div className={_cx('card-footer', className)} {...props}>
    {children}
  </div>
);
const Form: any = ({ children, onSubmit, className, ...props }: any) => (
  <form
    className={className}
    onSubmit={onSubmit || ((e: any) => e.preventDefault())}
    {...props}
  >
    {children}
  </form>
);
Form.Group = ({ className, controlId: _c, children, ...props }: any) => (
  <div className={_cx('mb-3', className)} {...props}>
    {children}
  </div>
);
Form.Label = ({ className, children, htmlFor, ...props }: any) => (
  <label className={_cx('form-label', className)} htmlFor={htmlFor} {...props}>
    {children}
  </label>
);
Form.Control = ({ as, className, children, isInvalid, ...props }: any) => {
  const cls = _cx('form-control', isInvalid && 'is-invalid', className);
  if (as === 'select')
    return (
      <select className={cls} {...props}>
        {children}
      </select>
    );
  if (as === 'textarea') return <textarea className={cls} {...props} />;
  return <input className={cls} {...props} />;
};
Form.Select = ({ className, children, isInvalid, ...props }: any) => (
  <select
    className={_cx('form-control form-select', isInvalid && 'is-invalid', className)}
    {...props}
  >
    {children}
  </select>
);
Form.Check = ({
  type = 'checkbox',
  label,
  id,
  className,
  inline,
  children,
  ...props
}: any) => (
  <div className={_cx('form-check', inline && 'form-check-inline', className)}>
    <input type={type} id={id} className="form-check-input" {...props} />
    {label !== undefined && (
      <label htmlFor={id} className="form-check-label">
        {label}
      </label>
    )}
    {children}
  </div>
);
Form.Text = ({ muted, className, children, ...props }: any) => (
  <small className={_cx('form-text', muted && 'text-muted', className)} {...props}>
    {children}
  </small>
);
const Modal: any = ({ show, onHide, size, centered: _c, children, className, ...props }: any) => {
  const sizeCls =
    size === 'sm'
      ? 'sm:max-w-md'
      : size === 'lg'
      ? 'sm:max-w-2xl'
      : size === 'xl'
      ? 'sm:max-w-6xl'
      : '';
  return (
    <Dialog open={!!show} onOpenChange={(o: boolean) => !o && onHide?.()}>
      <DialogContent
        className={`${sizeCls} max-h-[90vh] overflow-y-auto ${className || ''}`.trim()}
        {...props}
      >
        {children}
      </DialogContent>
    </Dialog>
  );
};
Modal.Header = ({ children, closeButton: _cb, className, ...props }: any) => (
  <DialogHeader className={className} {...props}>
    {children}
  </DialogHeader>
);
Modal.Title = ({ children, className, ...props }: any) => (
  <DialogTitle className={className} {...props}>
    {children}
  </DialogTitle>
);
Modal.Body = ({ children, className, ...props }: any) => (
  <div className={`overflow-x-auto ${className || ''}`.trim()} {...props}>
    {children}
  </div>
);
Modal.Footer = ({ children, className, ...props }: any) => (
  <DialogFooter className={className} {...props}>
    {children}
  </DialogFooter>
);
const Table: any = ({
  bordered,
  striped,
  hover,
  responsive: _r,
  className,
  children,
  ...props
}: any) => (
  <table
    className={_cx(
      'table',
      bordered && 'table-bordered',
      striped && 'table-striped',
      hover && 'table-hover',
      className,
    )}
    {...props}
  >
    {children}
  </table>
);
const _TabsCtx = React.createContext<any>({});
const Tabs: any = ({
  activeKey,
  defaultActiveKey,
  onSelect,
  children,
  className,
  ...props
}: any) => {
  const [internalKey, setInternalKey] = React.useState(defaultActiveKey || null);
  const current = activeKey !== undefined ? activeKey : internalKey;
  const handle = (k: any) => {
    if (activeKey === undefined) setInternalKey(k);
    onSelect?.(k);
  };
  const tabs = React.Children.toArray(children).filter(Boolean) as any[];
  if (current === null && tabs.length) {
    setInternalKey(tabs[0]?.props?.eventKey);
  }
  return (
    <_TabsCtx.Provider value={{ current, setKey: handle }}>
      <div className={className} {...props}>
        <ul className="nav nav-tabs" role="tablist">
          {tabs.map((t: any) => (
            <li key={t.props.eventKey} className="nav-item" role="presentation">
              <button
                type="button"
                className={_cx('nav-link', current === t.props.eventKey && 'active')}
                onClick={() => handle(t.props.eventKey)}
                disabled={t.props.disabled}
              >
                {t.props.title}
              </button>
            </li>
          ))}
        </ul>
        <div className="tab-content">
          {tabs.map((t: any) => (
            <div
              key={t.props.eventKey}
              className={_cx('tab-pane', current === t.props.eventKey && 'active show')}
              style={{ display: current === t.props.eventKey ? undefined : 'none' }}
            >
              {t.props.children}
            </div>
          ))}
        </div>
      </div>
    </_TabsCtx.Provider>
  );
};
const Tab: any = () => null;
const Tooltip: any = ({ children, id: _id, ...props }: any) => (
  <span {...props}>{children}</span>
);
const OverlayTrigger: any = ({ children, overlay, placement: _p, trigger: _t }: any) => {
  let title = '';
  if (overlay?.props?.children) {
    title =
      typeof overlay.props.children === 'string'
        ? overlay.props.children
        : Array.isArray(overlay.props.children)
          ? overlay.props.children.filter((c: any) => typeof c === 'string').join(' ')
          : '';
  }
  return React.cloneElement(children, { title });
};
const Badge: any = ({ bg, pill, className, children, ...props }: any) => (
  <span
    className={_cx('badge', bg && `bg-${bg}`, pill && 'rounded-pill', className)}
    {...props}
  >
    {children}
  </span>
);
const Spinner: any = ({ animation: _a, size, variant, className, ...props }: any) => (
  <span
    className={_cx(
      'spinner-border',
      size === 'sm' && 'spinner-border-sm',
      variant && `text-${variant}`,
      className,
    )}
    role="status"
    aria-hidden="true"
    {...props}
  />
);
import Select from 'react-select';
import { FiBriefcase, FiPhone, FiMapPin } from 'react-icons/fi';
import CountryCodeDirectionPicker from '@/components/partials/dashboard/country-code-direction/CountryCodeDirectionPicker';

// Icons above each text box have been removed at user request. The
// component signature keeps the props so every `<IconField icon={...} />`
// call-site below still type-checks, but the icon element is no longer
// rendered — the input simply sits on its own line under the label.
function IconField({ children }: { icon?: unknown; iconTop?: unknown; children: React.ReactNode }) {
  return <>{children}</>;
}

export default function RenderUserCompanyFields(props) {
  const [nameTouched, setNameTouched] = useState(false);
  const [phoneTouched, setPhoneTouched] = useState(false);
  const [pincodeTouched, setPincodeTouched] = useState(false);
  const [addressTouched, setAddressTouched] = useState(false);
  const [nameLiveWarning, setNameLiveWarning] = useState('');
  const [phoneLiveWarning, setPhoneLiveWarning] = useState('');

  // When the parent form's step validation fails, it flips `showAllErrors`
  // so every field surfaces its "required" message even if the user
  // hasn't touched it yet. The local touched-flags stay untouched so once
  // the user starts typing, live validation still behaves normally.
  const forceShow = Boolean(props.showAllErrors);

  const companyNameValue = props.company_name || '';
  const companyNameTrimmed = companyNameValue.trim();
  const companyNameError = nameLiveWarning
    ? nameLiveWarning
    : !nameTouched && !forceShow
    ? ''
    : !companyNameTrimmed
    ? 'Company name is required'
    : companyNameTrimmed.length < 2 || companyNameTrimmed.length > 100
    ? 'Company name must be between 2 and 100 characters'
    : '';

  const companyPhoneValue = props.company_phone || '';
  const companyPhoneError = phoneLiveWarning
    ? phoneLiveWarning
    : !phoneTouched && !forceShow
    ? ''
    : !companyPhoneValue
    ? 'Phone number is required'
    : companyPhoneValue.length !== 10
    ? 'Phone number must be exactly 10 digits'
    : '';

  const companyPincodeValue = props.company_pincode || '';
  const companyPincodeError = !pincodeTouched && !forceShow
    ? ''
    : !companyPincodeValue
    ? 'Pincode is required'
    : companyPincodeValue.length !== 6
    ? 'Pincode must be exactly 6 digits'
    : '';

  const companyAddressValue = props.company_address || '';
  const companyAddressLiveError =
    (addressTouched || forceShow) && !companyAddressValue.trim()
      ? 'Company address is required'
      : '';
  const companyAddressError = props.company_address_error || companyAddressLiveError;

  return (
    <div className="company-basic-fields">
      <div className="row g-3">
        <Form.Group className="col-12 col-lg-4 form-group mb-0">
          <Form.Label htmlFor="company_name">
            Company Name<span className="text-danger ms-1">*</span>
          </Form.Label>
          <IconField icon={FiBriefcase}>
            <Form.Control
              type="text"
              id="company_name"
              className={`ccf-input-with-icon__control${companyNameError ? ' is-invalid' : ''}`}
              placeholder="Enter company name"
              maxLength={100}
              value={props.company_name}
              onChange={(e) => {
                const value = e.target.value;
                setNameTouched(true);
                if (!/^[a-zA-Z0-9 ]*$/.test(value)) {
                  setNameLiveWarning('Special characters are not allowed in company name');
                  return;
                }
                setNameLiveWarning('');
                props.set_company_name(value);
              }}
              onBlur={() => setNameTouched(true)}
              required
            />
          </IconField>
          {companyNameError ? (
            <div className="invalid-feedback d-block">{companyNameError}</div>
          ) : null}
        </Form.Group>

        <Form.Group className="col-12 col-lg-4 form-group mb-0">
          <Form.Label htmlFor="company_phone">
            Phone<span className="text-danger ms-1">*</span>
          </Form.Label>
          <IconField icon={FiPhone}>
            <Form.Control
              type="tel"
              id="company_phone"
              className={`ccf-input-with-icon__control${companyPhoneError ? ' is-invalid' : ''}`}
              placeholder="10 digits"
              value={props.company_phone}
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, '');
                setPhoneTouched(true);
                if (value.length > 10) {
                  setPhoneLiveWarning('Phone number cannot be more than 10 digits');
                  return;
                }
                setPhoneLiveWarning('');
                props.set_company_phone(value);
              }}
              onBlur={() => setPhoneTouched(true)}
              required
            />
          </IconField>
          {companyPhoneError ? (
            <div className="invalid-feedback d-block">{companyPhoneError}</div>
          ) : null}
        </Form.Group>

        <Form.Group className="col-12 col-lg-4 form-group mb-0">
          <Form.Label htmlFor="company_pincode">
            Pincode<span className="text-danger ms-1">*</span>
          </Form.Label>
          <IconField icon={FiMapPin}>
            <Form.Control
              type="text"
              inputMode="numeric"
              pattern="[0-9]*"
              id="company_pincode"
              className={`ccf-input-with-icon__control${companyPincodeError ? ' is-invalid' : ''}`}
              placeholder="6 digits"
              value={props.company_pincode}
              onChange={(e) => {
                const onlyDigits = e.target.value.replace(/\D/g, '');
                setPincodeTouched(true);
                if (onlyDigits.length <= 6) {
                  props.set_company_pincode(onlyDigits);
                }
              }}
              onPaste={(e) => {
                const pasted = e.clipboardData.getData('text').replace(/\D/g, '');
                e.preventDefault();
                setPincodeTouched(true);
                props.set_company_pincode(pasted.slice(0, 6));
              }}
              onBlur={() => setPincodeTouched(true)}
              required
            />
          </IconField>
          {companyPincodeError ? (
            <div className="invalid-feedback d-block">{companyPincodeError}</div>
          ) : null}
        </Form.Group>
      </div>

      <div className="row g-3 mt-0">
        <Form.Group className="col-12 col-lg-4 form-group mb-0">
          <Form.Label htmlFor="company_address">
            Company Address<span className="text-danger ms-1">*</span>
          </Form.Label>
          <IconField icon={FiMapPin} iconTop>
            <Form.Control
              as="textarea"
              rows={2}
              id="company_address"
              className={`ccf-input-with-icon__control${companyAddressError ? ' is-invalid' : ''}`}
              placeholder="Street, city, state"
              maxLength={500}
              value={props.company_address}
              onChange={(e) => {
                setAddressTouched(true);
                props.set_company_address(e.target.value);
              }}
              onBlur={() => setAddressTouched(true)}
              required
            />
          </IconField>
          {companyAddressError ? (
            <div className="invalid-feedback d-block">{companyAddressError}</div>
          ) : null}
        </Form.Group>

        {props.locations && (
          <Form.Group className="col-12 col-lg-4 form-group mb-0">
            <Form.Label>Location</Form.Label>
            <IconField icon={FiMapPin}>
              <Select
                className="theme-react-select ccf-select-in-icon"
                classNamePrefix="theme-react-select"
                options={props.locations}
                value={props.locations.filter((l) => props.selectedLocation.includes(l.value))}
                onChange={(selected) =>
                  props.setSelectedLocation(selected.map((s) => s.value))
                }
                isMulti
                placeholder="Select Location"
              />
            </IconField>
          </Form.Group>
        )}

        {props.countryCodeDirections && (
          <div className="col-12 col-lg-4">
            <CountryCodeDirectionPicker
              items={props.countryCodeDirections}
              selectedIds={props.selectedCountryCodeDirections}
              onChange={props.setSelectedCountryCodeDirections}
              label="Country Codes"
              placeholder="Select country code"
              groupClassName="form-group mb-0"
              showSelectAll
            />
          </div>
        )}
      </div>
    </div>
  );
}
